export default __webpack_public_path__ + "static/media/okara_icon.28bb1ebf.png";